module.exports = __webpack_public_path__ + "img/nav-bottom-offers-active.94375704.png";